import React, { Component } from 'react'
import './main.scss'
import { Link } from "react-scroll"
import Contact from '../Contact/Contact.js'
import carl from './carl.png'
import awsCert from './aws_certified.png'
import VisibilitySensor from 'react-visibility-sensor'
import ReactGA from 'react-ga';
import Plans from '../Plans/Plans.js'

class Main extends Component {

    aboutChanged = (isVisible) => {
        if (isVisible) {
            document.getElementById('mobile-apps').classList.add('about-animate');

            setTimeout(function() {
                document.getElementById('web-dev').classList.add('about-animate');

                setTimeout(function() {
                    document.getElementById('cloud-services').classList.add('about-animate');

                    setTimeout(function() {
                        document.getElementById('aerial-photography').classList.add('about-animate');
                    }, 400)

                }, 400)

            }, 400)
        }
    };

    aerialPhotographyClicked = () => {
        ReactGA.event({
            category: 'User',
            action: 'Drone clicked'
        });
    }

  render() {
    return (
        <div>
            <title>ERC Solutions</title>
            <meta name="description" content="ERC Solutions is a software company in Swansea specialising in mobile apps, web design, aerial photography and IT consultancy." />
            <meta name="keywords" content="erc, erc solutions, website design, web design, web development, software, apps, mobile apps, software development, contracting, consultancy, bespoke, pfco, drone" />

            <header id="home" className="intro">
                <div className="container">
                    <div className="intro-text">
                        <h1>Welcome to ERC Solutions</h1>
                        <div>Innovative mobile apps, web design, aerial photography &amp; IT consultancy</div>
                        <Link
                            activeClass="active"
                            to="about"
                            spy={true}
                            smooth={true}
                            offset={-56}
                            duration={800}>
                            Get Started
                        </Link>
                    </div>
                </div>
            </header>

            <VisibilitySensor onChange={this.aboutChanged} partialVisibility={true} offset={{bottom:500}} >

                <section id="about">
                    <div className="img"></div>
                    <div className="container">
                        <div className="text-center">
                            <h5>What we offer</h5>
                            <div className="section-separator"></div>
                        </div>
                        <div className="row mb-4">
                            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
                                <div className={"text-center + this.state.animate"} id="mobile-apps" >
                                    <div className="icon">
                                        <i className="fas fa-mobile-alt"></i>
                                    </div>
                                    <h6 className="about-heading">Mobile apps</h6>
                                    <div className="text">We specialise in building native Android and iOS apps along with cross-platform apps in Xamarin. All apps are created with modern designs to the highest quality in a secure and robust manner using the latest industry standards.</div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
                                <div className="text-center" id="web-dev">
                                    <div className="icon">
                                        <i className="fas fa-desktop"></i>
                                    </div>
                                    <h6 className="about-heading">Web development</h6>
                                    <div className="text">Highly experienced in creating both beautiful, mobile responsive websites for small to medium organisations and full stack development for enterprise solutions in the public and private sector.</div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
                                <div className="text-center" id="cloud-services">
                                    <div className="icon">
                                        <i className="fas fa-cloud"></i>
                                    </div>
                                    <h6 className="about-heading">Cloud services</h6>
                                    <div className="text">From large scale transformation projects to Alexa skills, we can deliver easy, secure, scalable applications on major cloud platforms including AWS, Google and Azure to bring your innovate ideas to life.</div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-3">
                                <div className="text-center" id="aerial-photography">
                                    <div className="icon">
                                        <i className="fas fa-rocket"></i>
                                    </div>
                                    <h6 className="about-heading">Aerial photography & videos</h6>
                                    <div className="text">Fully certified and registered with the CAA, we can deliver stunning high definition aerial photography and videos.  Capture your imagination and tell your story from a birds eye view.</div>
                                    <a id="drone-see-more" href="https://www.evansabovephotography.co.uk" target="_blank" onClick={this.aerialPhotographyClicked}>See more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </VisibilitySensor>

            <section id="team" className="standard-section">
                <div className="container text-center">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <h5 className="mb-5">Our Team</h5>
                            <img className="mb-3" src={carl} alt="Carl Evans"/>
                            <h4>Carl Evans</h4>
                            <div className="mb-3">Software Developer</div>
                            <div className="social-links mb-4">
                                <a className="mr-4" href="http://www.carlrichardevans.me.uk">
                                    <i className="fas fa-globe-europe"></i>
                                </a>
                                <a className="mr-4" href="https://twitter.com/carlevanserc">
                                    <i className="fab fa-twitter"></i>
                                </a>
                                <a href="https://uk.linkedin.com/in/carl-evans-291b0266">
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                            </div>
                            <div className="desc">Carl has over 15 years experience in the IT industry working on a range of projects for both the public and private sector.  Carl spent 12 years with Fujitsu, gaining vast experience in architecting, developing and supporting small to large scale applications to customers around the world.  During the last 3 years, Carl has worked with the latest innovative technologies in areas such as Augmented Reality, IoT (Internet of Things) and Machine Learning.  Carl loves creating pixel perfect Android and iOS apps and worked with customers such as the NHS, Heathrow, Wateraid and Macmillan, winning two innovation awards in 2017, a Global Innovation Award with Wateraid for So-app and a National Healthcare Award for the NHS app Offload.</div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="skills">
                <div className="img"></div>
                <div className="container">
                    <h5 className="text-center mb-5">Skills</h5>
                    <div className="row justify-content-center">
                        <div className="col-4 col-md-2 offset-md-1 text-center mb-4">
                            <i className="fab fa-android mb-2"></i>
                            <h6>Android</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-apple mb-2"></i>
                            <h6>iOS</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-java mb-2"></i>
                            <h6>Java</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center mb-4">
                            <i className="fab fa-angular mb-2"></i>
                            <h6>AngularJS</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-react mb-2"></i>
                            <h6>ReactJS</h6>
                        </div>
                        <div className="col-4 col-md-2 offset-md-1 text-center mb-4">
                            <i className="fab fa-aws mb-2"></i>
                            <h6>AWS</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-html5 mb-2"></i>
                            <h6>HTML5</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-git mb-2"></i>
                            <h6>Git</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center mb-4">
                            <i className="fab fa-gulp mb-2"></i>
                            <h6>Gulp</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-css3-alt mb-2"></i>
                            <h6>CSS</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center mb-4">
                            <i className="fab fa-jenkins mb-2"></i>
                            <h6>Jenkins</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-bitbucket mb-2"></i>
                            <h6>Bitbucket</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-jira mb-2"></i>
                            <h6>JIRA</h6>
                        </div>
                        <div className="col-4 col-md-2 text-center">
                            <i className="fab fa-confluence mb-2"></i>
                            <h6>Confluence</h6>
                        </div>
                    </div>
                </div>
                <div id="aws-certified" className="text-center mt-4">
                    <img src={awsCert} alt="AWS Certification"/>
                </div>
            </section>

            <Plans />
            <Contact facebook="ercsolutionsltd" instagram="ercsolutions" />
        </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/Main.js